<template>
  <home-dashboard v-if="isWeb2UserConnected"/>
  <landing v-else/>
</template>

<script>
import { mapGetters } from 'vuex';

// "/" : the illustrated welcome page for visitors (full screen, no menus), the dashboard once signed in
const Landing = () => import('./Home.vue');
const HomeDashboard = () => import('./HomeDashboard.vue');

export default {
  name: 'Start',
  components: { Landing, HomeDashboard },
  computed: {
    ...mapGetters('user', ['isWeb2UserConnected'])
  }
};
</script>
